module.exports = __webpack_public_path__ + "img/haibao1@2x.5a9e4cf3.png";